import { z } from 'zod';
import { SequenceTypeEnum } from './SequenceType.enum';

// Schemas (source of truth) — pure validation, no transforms
export const sequenceSchema = z.object({
	_id: z.string(),
	projectId: z.string(),
	sequenceType: z.enum(SequenceTypeEnum),
	name: z.string(),
	orderIndex: z.number(),
	isInitial: z.boolean().optional(),
});

// Types (derived from schemas)
export type ISequence = z.infer<typeof sequenceSchema>;
export type ISequenceWithoutId = Omit<ISequence, '_id'>;
